import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useProjectCreate } from '@/module/Author/Project/model/ProjectQuery';
import { ProjectSchema, defaultProjectValues, projectSchema } from '@/module/Author/Project/model/ProjectSchema';

import { useAppNotification } from '@feature/utils';

import { ProjectForm } from './ProjectForm';

export function ProjectCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useProjectCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: ProjectSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newProject => {
        notification.success();
        navigate({ to: '/author/project/$projectId', params: { projectId: String(newProject.id) } });
      },
    });
  };

  return (
    <ProjectForm
      title={t('projects.form.title.create')}
      schema={projectSchema}
      defaultValues={defaultProjectValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
